import { render, staticRenderFns } from "./dateSelector.vue?vue&type=template&id=873126e8"
import script from "./dateSelector.vue?vue&type=script&lang=js"
export * from "./dateSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports